import { busesAPI } from "components/Apis/Buses";
import BlankSpace from "components/UI/Atoms/BlankCell";
import { makeNiceDate } from "components/Warehouse/helpers";
import { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import toast from "react-hot-toast";

export const HistoryModal = ({ order = null, bus = null }) => {
    const [showHistory, setShowHistory] = useState(false);
    const [historyData, setHistoryData] = useState(null);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (showHistory) {
            const toastId = toast.loading("Fetching history...");
            if (bus) {
                busesAPI.getUpdates(bus.id, searchText)
                    .then(data => {
                        setHistoryData(data);
                        toast.dismiss(toastId);
                    })
                    .catch(error => {
                        console.error("Error fetching bus updates:", error);
                        toast.error("Failed to fetch bus updates.");
                    });
            }

            else if (order) {
                toast.toast('Haha, you are trying to fetch order history, but this is not implemented yet!');
            }
        }
    }, [showHistory, searchText]);

    const handleCloseModal = () => setShowHistory(false);

    return (
        <>
            <div
                style={{ cursor: "pointer" }}
                className="order-history-link"
                onClick={() =>
                    setShowHistory(true)
                }
            >
                    Updated: {bus?.updated_at || "N/A"}
            </div>
            <Modal
                className="warehouse-order-history"
                show={showHistory}
                onHide={handleCloseModal}
            >
                <Modal.Header>
                    {/* <Modal.Title>{makeProNumber(row)} - Order Line History</Modal.Title> */}
                    <Modal.Title>
                        <div style={{ position: "relative" }}>
                            <input
                                className="history-search-input"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.key == 'Tab') {
                                        setSearchText(e.target.value);
                                    }
                                }}
                                placeholder={bus ? `Search ${bus.name} Order History` : `Search ${order.order_no} History`}
                                style={{
                                    paddingLeft: "46px" // Add padding to make room for the icon
                                }}
                            />
                            <div
                                style={{
                                    color: "#aaa",
                                    position: "absolute",
                                    top: "50%",
                                    left: "10px",
                                    transform: "translateY(-50%)",
                                    pointerEvents: "none" // Makes the icon non-interactive
                                }}
                            >
                                <i className="fa fa-search" />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table className="order-history-table" striped hover>
                        <thead>
                            <th>Updated Object</th>
                            <th>Action</th>
                            <th>Date</th>
                            <th>User</th>
                        </thead>
                        <tbody>
                            {historyData?.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {
                                            item.order
                                                ? <>{item.order_no} {item.order_group} {item.backorder}</>
                                                : item.bus?.name || <BlankSpace />
                                        }
                                    </td>
                                    <td>{item.message}</td>
                                    <td>{makeNiceDate(item.created_at)}</td>
                                    <td>
                                        {item.username.startsWith("atiq")
                                            ? "System"
                                            : item.username?.split("@")[0]}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <button className="button" variant="secondary" onClick={handleCloseModal}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};